import { dateNow } from 'utils/core/now';
import { getNewGuid } from 'utils/guid';
import { getFrontVersion } from 'utils/version';

import type { IHttpConfig, IHttpHeaders } from '../httpClient.model';

export default (config: IHttpConfig): IHttpConfig => {
  const headers: IHttpHeaders = {
    ...config.headers,
  };

  if (headers['X-Correlation-ID'] === undefined || headers['X-Correlation-ID'] === null) {
    headers['X-Correlation-ID'] = getNewGuid();
  }

  if (headers['front-version'] === undefined || headers['front-version'] === null) {
    headers['front-version'] = getFrontVersion();
  }

  headers.timestamp = dateNow();

  return {
    ...config,
    headers,
  };
};
